import React from 'react';

const Header = ({ title, description }) => (
  <header data-bem="Header--user" className="header">
    <span data-bem="Header__text" className="header-text">
      <h1>Slick</h1>
      {title}
      <span data-bem="Header__sub" className="header-sub">
        {description}
      </span>
    </span>
  </header>
);

export default Header;
